import React, { useState } from "react";
import styled from "styled-components";
import Paragraph from "../atoms/Paragraph";
import Button from "../atoms/Button";
import ArrowRight from "../atoms/icons/ArrowRight";
import { sendEditEmailRequest } from "../../services/dossierService";
import { useDispatch, useSelector } from "react-redux";
import InputItem from "../atoms/InputItem";
import ErrorNotice from "../atoms/ErrorNotice";
import { useTranslation } from "react-i18next";

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 20px;
`;

const StyledErrorNotice = styled(ErrorNotice)`
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledArrowRight = styled(ArrowRight)`
  width: 15px;
  height: 11px;
  fill: white;
`;

const StyledInputItem = styled(InputItem)`
  input {
    padding: 30px 20px 10px 10px;

    @media only screen and (min-width: 540px) {
      padding: 30px 20px 10px;
    }
  }
`;

const EditEmailModal = ({ onRequestClose }) => {
  const { t } = useTranslation(["common", "dossier"]);
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [editEmailState, setEditEmailState] = useState({
    email: "",
    email_confirmation: "",
  });

  const submit = e => {
    setLoading(true);
    setErrors({});
    e.preventDefault();

    const formData = new FormData();

    Object.keys(editEmailState).forEach(key =>
      formData.append(key, editEmailState[key])
    );

    dispatch(sendEditEmailRequest(formData))
      .then(response => {
        setErrors({});
        setLoading(false);
        setSuccess(true);
      })
      .catch(err => {
        setLoading(false);
        setErrors(err.errors);
      });
  };

  const handleChange = e => {
    setEditEmailState({ ...editEmailState, [e.target.name]: e.target.value });
  };

  return (
    <>
      {!success ? (
        <>
          <StyledParagraph>{t("dossier:update_email.intro")}</StyledParagraph>
          {errors.generic_error && (
            <StyledErrorNotice>{errors.generic_error}</StyledErrorNotice>
          )}
          <form onSubmit={submit}>
            <StyledInputItem
              label={t("dossier:update_email.email")}
              name="email"
              type="email"
              error={errors["email"]}
              disabled={loading}
              required
              onChange={handleChange}
            />
            <StyledInputItem
              label={t("dossier:update_email.confirm_email")}
              name="email_confirmation"
              type="email"
              error={errors["email_confirmation"]}
              disabled={loading}
              required
              onChange={handleChange}
            />
            <ButtonWrapper>
              <Button
                secondary
                reversed
                icon={<StyledArrowRight />}
                loading={loading ? 1 : 0}
              >
                {t("dossier:update_email.edit")}
              </Button>
            </ButtonWrapper>
          </form>
        </>
      ) : (
        <>
          <StyledParagraph>{t("dossier:update_email.updated")}</StyledParagraph>
          <Button primary wide onClick={onRequestClose}>
            {t("generic.close")}
          </Button>
        </>
      )}
    </>
  );
};

export default EditEmailModal;
